// src/admin/sections/AdminBlogs.jsx

import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  doc,
  setDoc,
  deleteDoc
} from "firebase/firestore";

import {
  ref,
  uploadBytes,
  getDownloadURL
} from "firebase/storage";

import imageCompression from "browser-image-compression"; // 🔥 NEW

import { db, storage } from "../../firebase/config";

export default function AdminBlogs() {

  const [blogs, setBlogs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [uploadingIndex, setUploadingIndex] = useState(null);
  const [saving, setSaving] = useState(false);

  // ================= LOAD =================
  useEffect(() => {
    const fetch = async () => {
      const snap = await getDocs(collection(db, "blogs"));

      const data = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setBlogs(data);
    };

    fetch();
  }, []);

  // ================= CHANGE =================
  const handleChange = (index, field, value) => {
    const updated = [...blogs];
    updated[index][field] = value;
    setBlogs(updated);
  };

  // ================= ADD =================
  const addBlog = () => {
    setBlogs([
      {
        id: Date.now().toString(),
        title: "",
        desc: "",
        content: "",
        img: "",
        date: new Date().toISOString().split("T")[0]
      },
      ...blogs
    ]);
  };

  // ================= 🔥 IMAGE UPLOAD (COMPRESSED) =================
  const handleImageUpload = async (file, index) => {
    if (!file) return;

    try {
      setUploadingIndex(index);

      // 🔥 COMPRESSION SETTINGS
      const options = {
        maxSizeMB: 0.3,               // ~300KB
        maxWidthOrHeight: 1200,       // resize large images
        fileType: "image/webp",       // 🔥 best format
        useWebWorker: true
      };

      // 🔥 COMPRESS IMAGE
      const compressedFile = await imageCompression(file, options);

      const storageRef = ref(
        storage,
        `blogs/${Date.now()}_${compressedFile.name}`
      );

      // 🔥 UPLOAD COMPRESSED FILE
      await uploadBytes(storageRef, compressedFile);

      const url = await getDownloadURL(storageRef);

      const updated = [...blogs];
      updated[index].img = url;
      setBlogs(updated);

    } catch (err) {
      console.error(err);
      alert("Image upload failed");
    }

    setUploadingIndex(null);
  };

  // ================= DELETE =================
  const removeBlog = async (id, index) => {
    if (!window.confirm("Delete this blog?")) return;

    await deleteDoc(doc(db, "blogs", id));

    const updated = blogs.filter((_, i) => i !== index);
    setBlogs(updated);
    setActiveIndex(null);
  };

  // ================= SAVE =================
  const saveAll = async () => {
    try {
      setSaving(true);

      for (let blog of blogs) {
        const { id, ...data } = blog;
        await setDoc(doc(db, "blogs", id), data);
      }

      alert("Blogs saved ✅");
    } catch (err) {
      console.error(err);
      alert("Error saving blogs");
    }

    setSaving(false);
  };

  return (
    <div className="admin-section admin-blogs">

      <h2>Blogs</h2>

      <button className="add-btn" onClick={addBlog}>
        + Add Blog
      </button>

      {/* LIST */}
      <div className="blogs-list">

        {blogs.map((blog, index) => (
          <div key={blog.id} className="blog-item">

            {/* HEADER */}
            <div
              className="blog-header"
              onClick={() =>
                setActiveIndex(activeIndex === index ? null : index)
              }
            >
              <img
                src={blog.img || "https://via.placeholder.com/60"}
                alt=""
              />

              <div>
                <h4>{blog.title || "Untitled Blog"}</h4>
                <span>{blog.date}</span>
              </div>
            </div>

            {/* BODY */}
            {activeIndex === index && (
              <div className="blog-body">

                {/* IMAGE UPLOAD */}
                <div className="image-upload">

                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      handleImageUpload(e.target.files[0], index)
                    }
                  />

                  {uploadingIndex === index && (
                    <p>Compressing & uploading...</p>
                  )}

                  {blog.img && (
                    <img
                      src={blog.img}
                      alt="preview"
                      className="preview-img"
                    />
                  )}
                </div>

                <input
                  placeholder="Title"
                  value={blog.title}
                  onChange={(e) =>
                    handleChange(index, "title", e.target.value)
                  }
                />

                <input
                  placeholder="Date (YYYY-MM-DD)"
                  value={blog.date}
                  onChange={(e) =>
                    handleChange(index, "date", e.target.value)
                  }
                />

                <textarea
                  placeholder="Short Description"
                  value={blog.desc}
                  onChange={(e) =>
                    handleChange(index, "desc", e.target.value)
                  }
                />

                <textarea
                  placeholder="Full Content"
                  value={blog.content}
                  onChange={(e) =>
                    handleChange(index, "content", e.target.value)
                  }
                  className="big-text"
                />

                <button
                  className="delete-btn"
                  onClick={() => removeBlog(blog.id, index)}
                >
                  Delete
                </button>

              </div>
            )}

          </div>
        ))}

      </div>

      {/* SAVE */}
      <button
        className="save-btn"
        onClick={saveAll}
        disabled={saving}
      >
        {saving ? "Saving..." : "Save All Blogs"}
      </button>

    </div>
  );
}